<template>
  <div>
    <div>
      <div class="info row gy-1 info-edit" v-if="!renderBillingInfo">
        <!-- user name -->
        <div class="col-md-12 col-lg-9">
          <div class="col-12 mb-2" v-if="contactInfo.email_address">
              <span class="">
              <strong>Email:</strong> {{contactInfo.email_address}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="contactInfo.phone_number">
            <span class="">
              <strong>Contact Number:</strong> {{contactInfo.phone_number}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="contactInfo.address1">
            <span class="">
              <strong>Address1:</strong> {{contactInfo.address1}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="contactInfo.address2">
            <span class="">
              <strong>Address2:</strong> {{contactInfo.address2}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="contactInfo.city">
            <span class="">
              <strong>City:</strong> {{contactInfo.city}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="contactInfo.state">
            <span class="">
              <strong>State:</strong> {{contactInfo.state}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="contactInfo.zip">
            <span class="">
              <strong>Zip:</strong> {{contactInfo.zip}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="contactInfo.birth_city">
            <span class="">
              <strong>Birth City:</strong> {{contactInfo.birth_city}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="contactInfo.birth_state">
            <span class="">
              <strong>Birth State:</strong> {{contactInfo.birth_state}}
            </span>
          </div>
        </div>
        <div class="col-md-12 col-lg-12 d-flex justify-content-end mt-0">
          <button @click="renderBillingInfo = true"
                  class="btn btn-personal-info-edit btn-outline-info info-edit-btn w-100 \"
          >
            <i class="fas fa-pen me-2"></i>
            Edit Details
          </button>
        </div>
      </div>
      <div v-if="renderBillingInfo">
        <contact-information :isRedirectionFromReview="true"
                             @cancelEditInfo="cancelEditInfo"
                             @updatedEditInfo="updatedEditInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import ContactInformation from "../ContactInformation";
export default {
  name: "ContactInfoEdit",
  props: {
    contactInfo: {
      type: Object
    }
  },
  data () {
    return {
      renderBillingInfo: false
    }
  },
  components: {
    ContactInformation
  },
  methods: {
    cancelEditInfo () {
      let app = this
      app.renderBillingInfo = false
    },
    updatedEditInfo () {
      let app = this
      app.renderBillingInfo = false
      app.$emit('updatedEditInfo')
    }
  }
}
</script>
<style src="@/assets/css/review_edit.css"></style>
<style scoped>
</style>